import { useRouter as useNextRouter } from "nextjs-toploader/app";

const useLink = () => {
  const router = useNextRouter();

  return ({
            href,
            scroll = true,
            target = "_self",
          }: {
    href: string;
    scroll?: boolean;
    target?: "_blank" | "_self";
  }) => {
    const isInternalLink =
      target === "_blank"
        ? false
        : href && (href.startsWith("/") || href.startsWith("#"));

    if (isInternalLink) {
      router.push(href, {
        scroll,
      });
    } else {
      window.open(href, target);
    }

    return false;
  };
};

export default useLink;
